import { type ReactNode, useState } from 'react'
import type { FormAnonymity } from '../utils/resolveIsAnonymous'
import { ReportFormContext } from './ReportFormContext'

type ReportFormProviderProps = {
  children: ReactNode
}

export const ReportFormProvider = ({ children }: ReportFormProviderProps) => {
  const [victimPin, setVictimPin] = useState<string | null>(null)
  const [createdAt, setCreatedAt] = useState<Date | null>(null)
  const [isSentReportAnonymous, setIsSentReportAnonymous] = useState<boolean | null>(null)
  const [tag, setTag] = useState<string | null>(null)
  const [formAnonymity, setFormAnonymity] = useState<FormAnonymity | null>(null)

  return (
    <ReportFormContext.Provider
      value={{
        victimPin,
        setVictimPin,
        createdAt,
        setCreatedAt,
        isSentReportAnonymous,
        setIsSentReportAnonymous,
        tag,
        setTag,
        formAnonymity,
        setFormAnonymity,
      }}
    >
      {children}
    </ReportFormContext.Provider>
  )
}
